export default "__VITE_PUBLIC_ASSET__e54c5c40__"